import { AfterViewInit, Directive, ElementRef, Input } from '@angular/core'

/**
 * Sets focus on the element if the directive is true.
 * usage: <div tabindex="0" hsAutofocus>
 * works on any focusable element:
 *  - tabindex must be set
 */
@Directive({ selector: '[hsAutofocus]' })
export class AutofocusDirective implements AfterViewInit {
  private _hsAutofocus = true
  @Input()
  set hsAutofocus(condition: boolean) {
    if (condition) {
      this.focusElement()
    } else {
      this.blurElement()
    }
    this._hsAutofocus = condition
  }

  constructor(private readonly el: ElementRef) {}

  ngAfterViewInit() {
    if (this._hsAutofocus) {
      this.focusElement()
    } else {
      this.blurElement()
    }
  }

  focusElement() {
    this.el.nativeElement.focus()

    // for testing purposes
    this.el.nativeElement.classList.add('hs-focused')
  }

  blurElement() {
    this.el.nativeElement.classList.remove('hs-focused')
  }
}
